import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "cds-marquee-alert elevation-3 sucess"
}
const _hoisted_2 = { class: "cds-marquee-alert__content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_ctx.isVisible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_v_avatar, {
          variant: "flat",
          color: "info",
          icon: "mdi-exclamation-thick"
        }),
        _createElementVNode("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "default", {}, () => [
            _createElementVNode("span", null, _toDisplayString(_ctx.message), 1)
          ])
        ]),
        _createVNode(_component_v_btn, {
          onClick: _ctx.close,
          class: "cds-marquee-alert__close-button",
          "aria-label": "Close alert",
          variant: "tonal"
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createTextVNode(" Close ", -1)
          ]))]),
          _: 1
        }, 8, ["onClick"])
      ]))
    : _createCommentVNode("", true)
}